import { Component, OnInit } from '@angular/core'
import { VersionService, VersionInfo } from 'src/app/services/version.service'

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.css'],
})
export class VersionComponent implements OnInit {
  frontendVersion: string = '-'
  frontendBuildDate: string = '-'
  backendVersion: string = '-'
  backendBuildDate: string = '-'
  backendName: string = '-'
  backendDescription: string = '-'
  isLoading: boolean = true

  constructor(private versionService: VersionService) {}

  ngOnInit() {
    this.loadVersions()
  }

  private loadVersions() {
    // Load frontend version
    this.versionService.getVersionInfo().subscribe({
      next: (info) => {
        this.frontendVersion = info.version
        this.frontendBuildDate = info.buildDateTime
      },
      error: () => {
        this.frontendVersion = '-'
        this.frontendBuildDate = '-'
      },
    })

    // Load backend version
    this.versionService.getBackendVersionInfo().subscribe({
      next: (info: VersionInfo) => {
        this.backendVersion = info.version
        this.backendBuildDate = info.buildDateTime
        this.backendName = info.instanceName
        this.backendDescription = info.instanceDescription
        this.isLoading = false
      },
      error: () => {
        this.backendVersion = '-'
        this.backendBuildDate = '-'
        this.backendName = '-'
        this.backendDescription = '-'
        this.isLoading = false
      },
    })
  }
}
